import { API_URL } from 'constants';

export const DOCUMENTS_UPLOAD_URL = `${API_URL}/api/v1/documents/upload`;

export const DOCUMENTS_INDEXING_STATUS_LATEST_URL = `${API_URL}/api/v1/documents/indexing-status/latest`;